"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  const displayItems = menuItems.slice(0, 3);
  return <nav className="flex gap-6">
      {displayItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-foreground-dark hover:underline hover:text-primary-hover transition-all duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <footer ref={ref} className={`bg-background-dark text-foreground-dark py-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-dark/80">© 2021&nbsp;AT &amp; E. All rights reserved.</p>

          <MenuProvider menu_id="3" className="order-first md:order-none">
            <FooterNavigation />
          </MenuProvider>

          <div className="flex items-center gap-4">
            <Link to="https://facebook.com" newTab className="text-foreground-dark hover:scale-110 hover:shadow-[0_4px_12px_rgba(255,255,255,0.2)] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-foreground-dark hover:scale-110 hover:shadow-[0_4px_12px_rgba(255,255,255,0.2)] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-foreground-dark hover:scale-110 hover:shadow-[0_4px_12px_rgba(255,255,255,0.2)] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}